import { render, staticRenderFns } from "./MailingAddressChoice.vue?vue&type=template&id=53ff1f70&scoped=true&"
import script from "./MailingAddressChoice.vue?vue&type=script&lang=js&"
export * from "./MailingAddressChoice.vue?vue&type=script&lang=js&"
import style0 from "./MailingAddressChoice.vue?vue&type=style&index=0&id=53ff1f70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../PatientEnrollment/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ff1f70",
  null
  
)

export default component.exports